import { createTheme } from "@mantine/core";

// Define your primary colors
export const primaryColors = [
  "#f8f0ff", // 0
  "#eedcff", // 1
  "#e2c6ff", // 2
  "#d6afff", // 3
  "#c99aff", // 4
  "#b163f1", // 5
  "#9f57d6", // 6
  "#8c4bbd", // 7
  "#7a40a5", // 8
  "#683894", // 9
];

// Create the theme object
export const theme = createTheme({
  colors: { primary: primaryColors },
  primaryColor: "primary",
  fontFamily: "Inter, sans-serif",
  headings: { fontFamily: "Inter, sans-serif", fontWeight: "700" },
});

// Create a CSS variables resolver
export const resolver = (theme) => ({
  variables: {
    "--mantine-color-black": "#162238",
    "--mantine-primary-color-0": theme.colors.primary[0],
    "--mantine-primary-color-1": theme.colors.primary[1],
    "--mantine-primary-color-2": theme.colors.primary[2],
    "--mantine-primary-color-3": theme.colors.primary[3],
    "--mantine-primary-color-4": theme.colors.primary[4],
    "--mantine-primary-color-5": theme.colors.primary[5],
    "--mantine-primary-color-6": theme.colors.primary[6],
    "--mantine-primary-color-7": theme.colors.primary[7],
    "--mantine-primary-color-8": theme.colors.primary[8],
    "--mantine-primary-color-9": theme.colors.primary[9],
    "--mantine-primary-color-filled": theme.colors.primary[5],
    "--mantine-primary-color-filled-hover": theme.colors.primary[6],
    "--mantine-primary-color-light": "rgba(177, 99, 241, 0.15)",
    "--mantine-primary-color-light-hover": "rgba(177, 99, 241, 0.2)",
    "--mantine-primary-color-light-color": theme.colors.primary[3],
    "--mantine-font-family-headings": "Inter, sans-serif",
    "--mantine-font-family": "Inter, sans-serif",
  },
});
